export enum TrainingSatisfactionFormState {
  Sent,
  Submitted,
}
